import { render, staticRenderFns } from "./ConcernCard.vue?vue&type=template&id=17a11d8f&scoped=true"
import script from "./ConcernCard.vue?vue&type=script&lang=js"
export * from "./ConcernCard.vue?vue&type=script&lang=js"
import style0 from "./ConcernCard.vue?vue&type=style&index=0&id=17a11d8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a11d8f",
  null
  
)

export default component.exports